import React from "react";
import useEmblaCarousel from "embla-carousel-react";
import { CarouselControls } from "~/common/components/card/CarouselControls";
import { CardListItem } from "~/common/api/page";
import { CardItem } from "./CardItem";
import { CardPostItem } from "~/common/api/post";
import { getCategoryLabel } from "~/utils/card";

export const CarouselContainer = ({
  items,
}: {
  items: CardListItem[] | CardPostItem[];
}) => {
  const [emblaRef, emblaApi] = useEmblaCarousel();
  const [currentItem, setCurrentItem] = React.useState(0);

  // we handle keeping track of the current slide for all cases
  // except when the user manually drags the slide left or right
  // listen for slidesInView to capture this case
  React.useEffect(() => {
    if (!emblaApi) return;

    const onMove = () => {
      setCurrentItem(emblaApi.selectedScrollSnap());
    };

    emblaApi.on("slidesInView", onMove);
    onMove();

    return () => {
      emblaApi.off("slidesInView", onMove);
    };
  }, [emblaApi]);

  const scrollTo = (index: number) => {
    emblaApi?.scrollTo(index);
    setCurrentItem(index);
  };

  return (
    <div className="tw:overflow-hidden" ref={emblaRef}>
      <div id="refCarousel" className="tw:flex tw:gap-4 tw:m-4">
        {items.map((item, index) => (
          <div key={index} style={{ flex: "0 0 100%", minWidth: "0" }}>
            <CardItem
              key={index}
              title={item.title}
              description={item.description}
              link={item.link}
              image={item.image}
              focalPoint={item.focalPoint}
              label={getCategoryLabel(item)}
              width="single"
            />
          </div>
        ))}
      </div>

      <CarouselControls
        currentItem={currentItem}
        totalItems={items.length ?? 0}
        onSelected={(slide) => scrollTo(slide)}
      />
    </div>
  );
};
